import { frontendURL } from 'dashboard/helper/URLHelper';

const CONVERSATION_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    name: 'tickets_list',
    meta: {
      permissions: CONVERSATION_PERMISSIONS,
    },
    component: () => import('./TicketListView.vue'),
  },
  {
    path: frontendURL(
      'accounts/:accountId/tickets/:conversationId'
    ),
    name: 'ticket_conversation',
    meta: {
      permissions: CONVERSATION_PERMISSIONS,
    },
    component: () => import('./TicketListView.vue'),
    props: route => ({
      conversationId: route.params.conversationId,
    }),
  },
];
